import { TipTapEditor } from "src/exports/elements/tip-tap-editor";
import { AttachmentManager } from "src/exports/attachment-manager";

TipTapEditor.define()

export {
  TipTapEditor,
	AttachmentManager
};
